import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

function passwordsMatch(control: AbstractControl): ValidationErrors | null {
  const newPassword = control.get('newPassword')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;
  return newPassword === confirmPassword ? null : { mismatch: true };
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  token: string | null = null;
  submitting = false;
  hidePassword = true;
  resetSucceeded = false;
  serverError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.resetForm = this.fb.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: passwordsMatch },
    );
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
  }

  submit(): void {
    if (this.resetForm.invalid || this.submitting || !this.token) return;
    this.submitting = true;
    this.serverError = null;
    const { newPassword } = this.resetForm.value;

    this.auth.resetPassword(this.token, newPassword).subscribe({
      next: () => {
        this.submitting = false;
        this.resetSucceeded = true;
      },
      error: (err) => {
        this.submitting = false;
        this.serverError = err.status === 400
          ? 'This reset link is invalid or has expired.'
          : 'Service unavailable, please try again';
      },
    });
  }

  openSignIn(): void {
    this.router.navigateByUrl('/').then(() => this.auth.openLoginDialog());
  }
}
